import { ArrayOps } from '../lift';
/**
 * Insert an Array of items at a specified index.
 */
export function insertAll(index, items) {
    var result = this.value().slice();
    result.splice.apply(result, [index, 0].concat(items));
    return new ArrayOps(result);
}
ArrayOps.prototype.insertAll = insertAll;
